export default __webpack_public_path__ + "static/media/pokemon_grass.f59b9ef7.png";